// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


import classnames from 'classnames'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Avatar from 'shared-web/src/components/Avatar'
import { captureExceptions } from 'utils/SentryHelpers'
import IconSVG from 'svg-inline-react'
import MakeInputChangeHandler from 'mixins/MakeInputChangeHandler'
import { fetchConnectedCalendars } from 'app/modules/meetings/actions'
import { getAgentIdsWithConnectedCalendars, isAgentIdsWithConnectedCalendarsPending } from 'app/modules/meetings/selectors'

import styles from 'styles/components/AssignDropdown.styl'

const AssignDropdown = React.createClass({
  mixins: [MakeInputChangeHandler],

  getInitialState() { return {} },

  componentDidMount() {
    if (this.props.calendarUsersOnly) {
      return this.props.actions.fetchConnectedCalendars()
    }
  },

  handleUserRowOnClick(userId) {
    return this.props.handleUserRowOnClick(userId)
  },

  render() {
    return (
      <div className={styles.AssignDropdown}>
        <div className="assign-header">
          <div className="title">
            {this.props.handleClearAssignee ?
              this.props.assignee ?
                <div onClick={this.props.handleClearAssignee} className="clear-assignee">
                  Clear Assignee
                </div>
              :
                'Assign to someone'
            :
              this.props.title}
          </div>
          <input
            type="text"
            autoFocus={true}
            placeholder="Search"
            onFocus={function(e) { return e.stopPropagation() }}
            valueLink={{
              value: this.state.input,
              requestChange: this.makeInputChangeHandler('input')
            }} />
        </div>
        <div className="assignee-rows">
          {_.map(this.getUsersToDisplay(), user => {
            const isAssignee = (this.props.assignee != null ? this.props.assignee.id : undefined) === user.id
            return (
              <div
                className={classnames('row', { 'is-assignee': isAssignee })}
                onClick={this.handleUserRowOnClick.bind(this, user.id)}>
                <Avatar user={user} selected={isAssignee} />
                <div className="name">
                  {user.name || user.email}
                </div>
                {isAssignee ?
                  <IconSVG
                    className="selected-check-mark"
                    src={require('!svg-inline?removeTags=true!images/icons/check-mark-icon.svg')} /> : undefined}
              </div>
            )
          })}
        </div>
      </div>
    )
  },

  getUsersToDisplay() {
    let { users } = this.props
    if (this.props.calendarUsersOnly) {
      users = _.filter(users, user => (this.props.calendarUserIds != null ? this.props.calendarUserIds.contains(user.id) : undefined))
    }
    if (this.state.input) {
      users = _.filter(users, value => {
        return _.includes(value.name != null ? value.name.toLowerCase() : undefined, this.state.input.toLowerCase())
      })
    }
    return users
  }
})

const withCalendarUserIds = connect(
  state => ({
    calendarUserIds: getAgentIdsWithConnectedCalendars(state),
    connectedCalendarsPending: isAgentIdsWithConnectedCalendarsPending(state)
  }) ,
  dispatch => ({
    actions: bindActionCreators({ fetchConnectedCalendars }, dispatch)
  })
 )

const withUsers = function(WrappedComponent) {
  return Marty.createContainer(WrappedComponent, {
    listenTo: ['stores.UserStore'],

    fetch: {
      users() {
        return this.app.stores.UserStore.getOrFetchActiveUsersForCurrentUserOrg()
      }
    },

    failed(errors) {
      captureExceptions(errors)
      return <div />
    }
  })
}

const AssignDropdownContainer = withUsers(withCalendarUserIds(AssignDropdown))

export default AssignDropdownContainer



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/AssignDropdown.js